import formatters from '../../../../../modules/Gull/Framework/formatters.js';
import validation from '../../../../../modules/Gull/Framework/validation.js';

const individueel = {

	init() {

		// Initialiseer stappen
		individueel.initSteps();

		// Verkrijg stap nummer uit navigatie tabs
		var stap = $('.nav-tabs').data('stap');

		// Fade de content in
		$('.tab-content').hide().removeClass('d-none').fadeIn(300);

		// Toon het introductiemodal in stap 1
		if (stap == 1) {
			$('.modal-naverrekening-introductie').modal('show', {
				backdrop: 'static',
				keyboard: false
			});
		}

		// Javascript t.b.v. stap 1
		if (stap == 2) {

			// Bind functie om het format van het periodeLoon af te dwingen aan input
			$('input.periodeLoon').change(function() {
				individueel.formatPeriodeloon();
			});

			// Format het periodeLoon als de pagina geladen wordt
			individueel.formatPeriodeloon();

		}

		// Javascript t.b.v. stap 3
		if (stap == 3) {

			// Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
			$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
			$('form[data-validate]').submit(async function() {
				let validated = await validation.checkSubmitForm(this);
				if (validated) {
					$('.modal-naverrekening-indienen').modal('show');
					$('.btn-definitief-indienen').click(function() {
						$('form[data-validate]').unbind('submit');
						$('form[data-validate]').submit();
						$('#loadingModal').modal('show', {
							keyboard: false,
							backdrop: 'static'
						});
					});
				}
				return false;
			});

		}

		// Javascript t.b.v. stap 9
		if (stap == 9) {

			// Enable de input als de checkbox van de input-group aangevinkt wordt
			$('.input-group-addon input[type="checkbox"]').change(function() {
				var checked = $(this).is(':checked');
				if (checked) {
					$(this).closest('tr').find('input[type="text"]').removeAttr('disabled');
					$(this).closest('tr').find('input[type="text"]').each(function() {
						validation.addRequired(this);
					});
					$(this).closest('tr').find('.input-group input[type="text"]:first-of-type').focus();
				} else {
					$(this).closest('tr').find('input[type="text"]').attr('disabled', 'true');
					$(this).closest('tr').find('input[type="text"]').each(function() {
						validation.removeRequired(this);
					});
				}
			});
			$('.input-group-addon input').trigger('change');
		}


	},

	// Functie om het format van het periodeLoon af te dwingen
	formatPeriodeloon: function() {
		var periodeLoonVerloondSV = $('#periodeLoonVerloondSV').val();
		periodeLoonVerloondSV = formatters.currencyNoSeparator(periodeLoonVerloondSV);
		$('#periodeLoonVerloondSV').val(periodeLoonVerloondSV);
	},

	// Functie om de stappen te initialiseren
	initSteps: function() {

		// Tel totaal aantal tabs (stappen)
		var stepsTotal = $('.sw-main ul.nav-tabs li').length;

		// Nummer de stappen op basis van aanwezig aantal tabs
		$('.nav-tabs li a b.step-number').each(function(i) {
			$(this).text(i + 1);
		});

		// Bereken de breedte van de tabs
		$('.sw-main ul.nav-tabs li').css('width', 'calc((100%)/' + stepsTotal + ')');

		// Fade de tabs in
		$('.sw-main').hide().removeClass('d-none').fadeIn(300);

	}

};

export default individueel;
